module.exports = __webpack_public_path__ + "img/capture.f35da762.png";